import React from "react";
import { type UscLabelType, UscLabel } from "../../../../../utils/labels";
import { useUscSelector } from "../../../../../redux/store";
import useSaveTyCode from "../../../../../hooks/useSaveTyCode";
import Button from "../../../../../../shared-components/toyota/styles/atoms/Button";
import Preloader from "../../../../../../shared-components/toyota/styles/molecules/Preloader";
import * as PreloaderStyles from "../../../../../../shared-components/toyota/styles/molecules/Preloader.styles";

type PropsType = {
    label: UscLabelType;
    icon: JSX.Element;
    onClick: (tyCode?: string | null) => void;
    openNewTab?: boolean;
    buttonVariant: "basket-cta" | "icon-text";
};
/**
 * Helper component that require a tyCode to be saved,
 * Will take care of tyCode saving and displaying a loading state.
 */
const SaveCodeCtaButton = (props: PropsType): JSX.Element | null => {
    const { label, icon, onClick, openNewTab, buttonVariant } = props;
    const save = useUscSelector((state) => state.save);
    const saveCode = useSaveTyCode(onClick, openNewTab);

    return (
        <Button variant={buttonVariant} onClick={saveCode.wrappedCallback}>
            {icon}
            <UscLabel label={save.saving && saveCode.loading ? "uscBasketCtaLoading" : label} />
            {save.saving && saveCode.loading && (
                <PreloaderStyles.LoadingWrapper>
                    <Preloader size={16} />
                </PreloaderStyles.LoadingWrapper>
            )}
        </Button>
    );
};

export default SaveCodeCtaButton;
